import React from 'react';
import { styled } from '@mui/material/styles';
import ReactMarkdown from 'react-markdown';
import { Link, LinkProps, Typography, TypographyProps } from "@mui/material";
import classNames from 'classnames';
import { isAbsoluteUrl } from './isAbsoluteUrl';

const PREFIX = 'MarkdownRenderer';

const classes = {
  markdown: `${PREFIX}-markdown`,
};

const StyledReactMarkdown = styled(ReactMarkdown)(({ theme }) => ({
  [`&.${classes.markdown}`]: {
    '& ol, & ul': {
      margin: theme.spacing(1, 0),
      lineHeight: 1.5,
    },
    '& p': {
      marginBottom: theme.spacing(1.5),
    },
    '& blockquote': {
      borderLeft: `3px solid ${theme.palette.secondary.main}`,
      margin: theme.spacing(1, 0),
      padding: theme.spacing(0, 2),
    },
  },
}));

interface IProps {
  source: string;
  disallowedInline?: string[];
  disallowedBlock?: string[];
  noSplitOnNewLine?: boolean;
  className?: string;
  LinkComponent?: React.ComponentType<LinkProps>;
}

const MuiParagraph = (props: TypographyProps) => <Typography {...props} variant={'body1'} />;

export const MarkdownRenderer = (props: IProps) => {
  const source = props.noSplitOnNewLine
    ? props.source
    : props.source
        .split('\n')
        .map(line => (line.trim() === '' ? '\n' : `${line}  \n`))
        .join('');

  const linkTargetResolver = React.useCallback((url: string) => (isAbsoluteUrl(url) ? '_blank' : '_self'), []);

  return (
    <StyledReactMarkdown
      className={classNames(classes.markdown, props.className)}
      source={source}
      linkTarget={linkTargetResolver}

      plugins={[
        [
          require('remark-disable-tokenizers'),
          {
            inline: props.disallowedInline,
            block: props.disallowedBlock,
          },
        ],
      ]}
      renderers={{
        delete: Noop,
        paragraph: MuiParagraph,
        link: props.LinkComponent ?? Link,
      }}
    />
  );
};

const Noop = props => props.children;
